export default{
    loaderWithOverlay:'loader-wrapper overlay',
    loaderClass:'loader-wrapper',
    loader:'loader',
    classList:'classList',
    objectType:'object',
    hasWrapper:'hasWrapper',
    emptySpace:' '
};